import { cleanPhone } from '../../../utils/phoneUtils';

interface LeadWithContact {
    stage?: string;
    stage_id?: string;
    contact?: {
        phone?: string;
        whatsapp?: string;
    } | Array<{
        phone?: string;
        whatsapp?: string;
    }>;
}

interface StageInfo {
    id: string;
    name: string;
}

/**
 * Cria um mapa de nome de estágio por ID
 */
export function buildStageNameMap(stages: StageInfo[]): Map<string, string> {
    const map = new Map<string, string>();
    stages.forEach(s => map.set(s.id, s.name));
    return map;
}

/**
 * Cria um mapa de telefone para nome de estágio
 * Gera variantes para cobrir diferenças de formatação BR
 */
export function buildLeadStageMap(
    leads: LeadWithContact[],
    stageNameMap: Map<string, string>
): Map<string, string> {
    const leadStageMap = new Map<string, string>();

    const addToMap = (key: string, stageName: string) => {
        if (key && !leadStageMap.has(key)) {
            leadStageMap.set(key, stageName);
        }
    };

    leads.forEach((lead) => {
        // Extrai telefone do contato relacionado
        let rawPhone: string | null = null;
        if (lead.contact) {
            const contact = Array.isArray(lead.contact) ? lead.contact[0] : lead.contact;
            rawPhone = contact?.phone || contact?.whatsapp || null;
        }

        // Resolve nome do estágio
        const stageId = lead.stage || lead.stage_id;
        const stageName = stageId ? stageNameMap.get(stageId) : undefined;

        if (!rawPhone || !stageName) return;

        const cleanP = cleanPhone(rawPhone);

        // 1. Número original limpo
        addToMap(cleanP, stageName);

        // 2. Variantes BR com prefixo 55
        if (cleanP.startsWith('55')) {
            const withoutPrefix = cleanP.substring(2);
            addToMap(withoutPrefix, stageName);

            // 13 dígitos (55 + DDD + 9 + número): gera sem 9
            if (cleanP.length === 13) {
                const without9 = cleanP.substring(0, 4) + cleanP.substring(5);
                addToMap(without9, stageName);
                addToMap(without9.substring(2), stageName);
            }
            // 12 dígitos (55 + DDD + número sem 9): gera com 9
            else if (cleanP.length === 12) {
                const with9 = cleanP.substring(0, 4) + '9' + cleanP.substring(4);
                addToMap(with9, stageName);
                addToMap(with9.substring(2), stageName);
            }
        }
        // 3. Sem prefixo 55
        else {
            addToMap(`55${cleanP}`, stageName);

            // 11 dígitos (DDD + 9 + número): gera sem 9
            if (cleanP.length === 11) {
                const without9 = cleanP.substring(0, 2) + cleanP.substring(3);
                addToMap(without9, stageName);
                addToMap(`55${without9}`, stageName);
            }
            // 10 dígitos (DDD + número sem 9): gera com 9
            else if (cleanP.length === 10) {
                const with9 = cleanP.substring(0, 2) + '9' + cleanP.substring(2);
                addToMap(with9, stageName);
                addToMap(`55${with9}`, stageName);
            }
        }
    });

    return leadStageMap;
}
